<template>
    <rkm-form
        v-if="model"
        ref="RkmForm"
        show-legend
    >
        <rkm-row>
            <rkm-col cols="6">
                <rkm-form-select
                    :options="form.unidades"
                    :validations="validations.unidade"
                    @change="handleUnidadeChange"
                    label="Unidade"
                    show-default-option
                    text-field="nomeFantasia"
                    v-model="model.unidadeId"
                    value-field="id"
                />
            </rkm-col>

            <rkm-col cols="6">
                <rkm-form-select
                    :options="form.infraestruturas"
                    :validations="validations.infraestrutura"
                    @change="handleInfraestruturaChange"
                    label="Local de atendimento"
                    show-default-option
                    text-field="nome"
                    v-model="model.infraestruturaId"
                    value-field="id"
                />
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col cols="6">
                <rkm-form-select
                    :options="form.usuarios"
                    :validations="validations.usuario"
                    label="Profissional"
                    show-default-option
                    text-field="nome"
                    v-model="model.usuarioId"
                    value-field="id"
                />
            </rkm-col>
        </rkm-row>
    </rkm-form>
</template>

<script>
// Mixins.
import {error, repository, stringCase} from '@/mixins'

// Vuex.
import {mapActions} from 'vuex'

export default {
    computed: {
        validations() {
            return {
                unidade: {required: true},
                infraestrutura: {required: true},
                usuario: {required: true},
            }
        },
    },
    created() {
        this.repositories = {
            supervisor: this.getConectaSusRepository('farmacia.supervisor'),
        }
    },
    data: () => ({
        form: null,
        model: null,
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {
            this.setLoading()

            if (this.id) {
                this.repositories.supervisor.edit(this.id)
                    .then(response => {
                        this.form = Object.assign(response.data.form)
                        this.model = Object.assign(response.data.model)
                    })
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())
            } else {
                this.repositories.supervisor.create()
                    .then(response => {
                        this.form = Object.assign(response.data.form)
                        this.model = Object.assign(response.data.model)
                    })
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())
            }
        },
        handleUnidadeChange(value) {
            this.form.infraestruturas = []
            this.form.usuarios = []
            this.model.infraestruturaId = null
            this.model.usuarioId = null

            if (value === null) return

            this.getInfraestruturas(value)
        },
        handleInfraestruturaChange(value) {
            this.form.usuarios = []
            this.model.usuarioId = null

            if (value === null) return

            this.getUsuarios(value)
        },
        save() {
            this.$refs.RkmForm.validate()
                .then(valid => {
                    if (valid === false) return

                    this.setLoading()

                    const request = {
                        infraestruturaId: this.model.infraestruturaId,
                        usuarioId: this.model.usuarioId,
                    }

                    if (this.id) {
                        this.repositories.supervisor.update(this.id, this.camelObjectKeysToSnakeRecursive(request))
                            .then(response => {
                                this.$emit('saved', response)
                                this.showSaveNotification()
                            })
                            .catch(this.handleError)
                            .finally(() => this.unsetLoading())
                    } else {
                        this.repositories.supervisor.store(this.camelObjectKeysToSnakeRecursive(request))
                            .then(response => {
                                this.$emit('saved', response)
                                this.showSaveNotification()
                            })
                            .catch(this.handleError)
                            .finally(() => this.unsetLoading())
                    }
                })
        },
        async getInfraestruturas(unidadeId) {
            const request = {
                listar: 'infraestruturas',
                unidadeId,
            }

            this.setLoading()

            try {
                const response = await this.repositories.supervisor.list(this.camelObjectKeysToSnakeRecursive(request))

                this.form.infraestruturas = response.data

                if (this.form.infraestruturas.length === 1) {
                    const selected = this.form.infraestruturas[0]
                    this.model.infraestruturaId = selected.id

                    this.getUsuarios(this.model.infraestruturaId)
                }
            }
            catch (error) {
                this.handleError(error)
            }
            finally {
                this.unsetLoading()
            }
        },
        async getUsuarios(infraestruturaId) {
            const request = {
                listar: 'usuarios',
                infraestruturaId,
            }

            this.setLoading()

            try {
                const response = await this.repositories.supervisor.list(this.camelObjectKeysToSnakeRecursive(request))

                this.form.usuarios = response.data

                if (this.form.usuarios.length === 1) {
                    const selected = this.form.usuarios[0]
                    this.model.usuarioId = selected.id
                }
            }
            catch (error) {
                this.handleError(error)
            }
            finally {
                this.unsetLoading()
            }
        },
    },
    mixins: [error, repository, stringCase],
    mounted() {
        this.load()
    },
    props: {
        id: {type: Number},
    },
}
</script>